import { StopSearch } from "@catchy/ui";
import useLocalStorage from "hooks/useLocalStorage";
import { getMapCenterDefault, getStorageKey } from "@/lib/regions/client";
import { getEffectiveStopType } from "@/lib/stopTypes";
export default function Search(props) {
  const {
    center
  } = getMapCenterDefault();
  return <StopSearch {...props} searchType="all" useLocalStorage={useLocalStorage} favouritesStorageKey={getStorageKey("favourites")} fallbackLocation={{
    latitude: center.lat,
    longitude: center.lng
  }} resolveStopType={getEffectiveStopType} />;
}